import { render, staticRenderFns } from "./ScoreResourceNavigation.vue?vue&type=template&id=8720e3f8&scoped=true&"
import script from "./ScoreResourceNavigation.vue?vue&type=script&lang=js&"
export * from "./ScoreResourceNavigation.vue?vue&type=script&lang=js&"
import style0 from "./ScoreResourceNavigation.vue?vue&type=style&index=0&id=8720e3f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8720e3f8",
  null
  
)

export default component.exports